<template>
  <div class="team-page">
    <div class="page-header">
      <h1>核心团队</h1>
      <p class="subtitle">汇聚顶尖人才，引领行业创新</p>
    </div>

    <!-- 人物卡片区域 -->
    <div class="team-cards">
      <div
        v-for="member in teamMembers"
        :key="member.id"
        class="member-card"
        :class="{ active: selectedId === member.id }"
        @click="selectMember(member.id)"
      >
       <!-- <div class="photo-wrapper">
          <img :src="member.photo" :alt="member.name" />
          <div class="photo-overlay">
            <span class="view-btn">查看详情</span>
          </div>
        </div>-->
        <div class="member-info">
          <h3 class="member-name">{{ member.name }}</h3>
          <p class="member-title">{{ member.title }}</p>
        </div>
      </div>
    </div>

    <!-- 简历详情区域 -->
    <div class="resume-section" :key="selectedId">
      <div class="resume-container">
        <div class="resume-header">
          <h2>{{ currentMember.name }}</h2>
          <p class="resume-title">{{ currentMember.title }}</p>
        </div>

        <div class="resume-content">
          <div v-for="(section, index) in currentMember.resume" :key="index" class="resume-block">
            <h4 class="section-title">{{ section.heading }}</h4>
            <div class="section-body" v-html="section.content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoreTeam',
  data() {
    return {
      selectedId: 'wangcheng',
      teamMembers: [
        {
          id: 'wangcheng',
          name: '王成',
          title: '总经理 / CEO',
          photo: 'https://ui-avatars.com/api/?name=王成&background=0D8ABC&color=fff&size=200',
          resume: [
            {
              heading: '教育背景',
              content: `
                <ul>
                  <li><strong>北京大学环境学院</strong>，环境科学学士学位（2000.9-2004.7）</li>
                  <li><strong>中国科学院地理所</strong>，环境科学硕士学位（2004.9-2007.7）</li>
                </ul>
              `
            },
            {
              heading: '工作经历',
              content: `
                <p><strong>2007年7月-2010年5月</strong>：北京能源与交通创新中心，低碳交通项目分析师。主要负责可持续交通理论研究、新能源汽车标准及政策研究。</p>
                <p><strong>2010年6月-2017年</strong>：中国汽车技术研究中心，市场与政策研究部项目总监。从2011年开始负责产品研发、客户洽谈、商务对接、项目执行等完整流程管控，个人每年维护超过30家客户，软课题项目平均年产值300万以上。</p>
                <p><strong>2018年至今</strong>：接管北龙泽达（北京）数据科技有限公司，担任总经理。公司由中科院计算机网络信息中心出资筹建，承担科技成果产业孵化任务，是大数据分析与计算技术国家地方联合工程实验室唯一指定的产业化运营单位。</p>
                <p><strong>2019年8月至今</strong>：成立北京中科泽达科技有限公司，担任CEO。获得方信资本天使轮700万投资，北京、涿州双中心运营。</p>
              `
            },
            {
              heading: '主要成就',
              content: `
                <ul>
                  <li>2011年开发商用车发动机整车整备月度监测报告，售价30万/年，为汽研中心定价最高的月报产品，国内外知名发动机厂商60%发展为客户的</li>
                  <li>2012年开发天然气汽车月度监测报告，快速成为行业知名专家，2013-2016每年为20-30场行业会议做主旨演讲</li>
                  <li>2015年、2016年分别在成都、厦门主持举办天然气汽车展，直接签署展览合同过千万元</li>
                  <li>2017年与中国科学院计算机网络信息中心联合申报的大数据分析与计算技术国家联合工程实验室获国家发改委批准，担任实验室副主任</li>
                  <li>2018年个人出资收购北龙泽达49%股份，带领公司实现年营收900万元</li>
                </ul>
              `
            }
          ]
        },
        {
          id: 'zhanglei',
          name: '张磊',
          title: '副总经理 / 首席科学家',
          photo: '../../../../static/zl.png',
          resume: [
            {
              heading: '学术背景',
              content: `
                <p>张磊博士负责北龙泽达AI智算云技术产品体系建设与创新，同时兼职担任清华大学国家级高层次人才联聘教授。之前担任阿里云副总裁、产业AI首席科学家，全球知名高校终身制正教授、研究院院长。</p>
                <p>在AI+应用领域，张磊博士融合人工智能与垂直领域的跨学科技术经验，聚焦智慧城市、智能交通、低空经济、自动驾驶、时空智能等方向的科研创新与技术转化。</p>
              `
            }
          ]
        },
        
        {
          id: 'yangchengguan',
          name: '杨成关',
          title: '副总经理 / 法务总监',
          photo: 'https://ui-avatars.com/api/?name=杨成关&background=6366f1&color=fff&size=200',
          resume: [
            {
              heading: '教育背景',
              content: `
                <ul>
                  <li><strong>中国政法大学</strong>，法学学士（2010-2014）</li>
                  <li><strong>中国政法大学</strong>，法学硕士，民法学方向（2015-2018）</li>
                </ul>
              `
            },
            {
              heading: '职业经历',
              content: `
                <p><strong>2018-2020年</strong>：北京市嘉源律师事务所律师。主要从事A股、H股IPO业务，参与尽职调查、撰写律师工作报告、法律意见书等；参与多家A股、H股常年法律顾问服务。</p>
                <p><strong>2020-2022年</strong>：北京市通商律师事务所主办律师。主要从事H股IPO业务及基金投资业务，代表基金对被投资企业进行法律尽职调查，起草交易文件。</p>
                <p><strong>2022年至今</strong>：北龙泽达（北京）数据科技有限公司副总经理。负责公司日常运营、人员管理、项目拓展及合规体系建设。</p>
              `
            },
            {
              heading: '主要项目成绩',
              content: `
                <ul>
                  <li><strong>鲁商服务（02376.HK）H股IPO</strong>：中国境内律师签字律师，深度参与现场尽职调查、重组架构方案设计、法律意见书撰写、国资委国有股东标识批复、中国证监会国际部材料申报及问题回复等</li>
                  <li><strong>亚世光电（002952）A股IPO</strong>：深度参与现场尽职调查、新三板摘牌及三类股东问题处理、起草律师工作报告及法律意见书；上市后负责常年法律服务</li>
                  <li><strong>新天绿色能源（600956/00956.HK）H股回A</strong>：参与法律尽职调查、合规证明开具等工作</li>
                  <li><strong>基金投资业务</strong>：代表某军民融合基金参与十余项股权投资项目，负责尽职调查、出具法律意见书、起草交易文件、协助交易谈判</li>
                  <li><strong>中国建材吸收合并中材股份</strong>：参与两家H股上市公司合并项目的尽职调查、法律意见书出具、国务院国资委方案审批等</li>
                </ul>
              `
            },
            {
              heading: '公司管理',
              content: `
                <p>加入北龙泽达后，深度参与国家科研院所孵化的创业公司管理，参与包括北龙泽达、中科泽达、中科知道等公司的管理运营。</p>
                <p>负责公司日常人员及财务管理、内控体系建设、上级单位及投资人沟通、资质建设、研发补贴申请及部分业务拓展工作。</p>
              `
            }
          ]
        }
      ]
    }
  },
  computed: {
    currentMember() {
      return this.teamMembers.find(m => m.id === this.selectedId) || this.teamMembers[0]
    }
  },
  methods: {
    selectMember(id) {
      this.selectedId = id
      // 滚动到简历区域
      this.$nextTick(() => {
        const resumeSection = document.querySelector('.resume-section')
        if (resumeSection) {
          resumeSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      })
    }
  }
}
</script>

<style scoped>
.team-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  color: #1a1a1a;
  background: #fafafa;
  min-height: 100vh;
}

.page-header {
  text-align: center;
  margin-bottom: 60px;
}

.page-header h1 {
  font-size: 42px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 12px;
  letter-spacing: 2px;
}

.subtitle {
  font-size: 18px;
  color: #666;
  font-weight: 300;
}

/* 人物卡片 */
.team-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  margin-bottom: 60px;
}

.member-card {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid transparent;
}

.member-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.member-card.active {
  border-color: #0D8ABC;
  box-shadow: 0 8px 30px rgba(13, 138, 188, 0.2);
}

.photo-wrapper {
  position: relative;
  width: 100%;
  height: 280px;
  overflow: hidden;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.photo-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.member-card:hover .photo-wrapper img {
  transform: scale(1.05);
}

.photo-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.member-card:hover .photo-overlay {
  opacity: 1;
}

.view-btn {
  color: #fff;
  border: 2px solid #fff;
  padding: 8px 24px;
  border-radius: 24px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1px;
}

.member-info {
  padding: 24px;
  text-align: center;
}

.member-name {
  font-size: 22px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 6px;
}

.member-title {
  font-size: 14px;
  color: #0D8ABC;
  font-weight: 500;
}

/* 简历区域 */
.resume-section {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  animation: fadeIn 0.5s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.resume-header {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  color: #fff;
  padding: 40px 50px;
}

.resume-header h2 {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 8px;
}

.resume-title {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 400;
}

.resume-content {
  padding: 40px 50px;
}

.resume-block {
  margin-bottom: 36px;
}

.resume-block:last-child {
  margin-bottom: 0;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 16px;
  padding-bottom: 10px;
  border-bottom: 2px solid #0D8ABC;
  display: inline-block;
}

.section-body {
  font-size: 15px;
  line-height: 1.8;
  color: #444;
}

.section-body p {
  margin-bottom: 12px;
}

.section-body ul {
  list-style: none;
  padding: 0;
}

.section-body ul li {
  position: relative;
  padding-left: 20px;
  margin-bottom: 10px;
}

.section-body ul li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 10px;
  width: 6px;
  height: 6px;
  background: #0D8ABC;
  border-radius: 50%;
}

.section-body strong {
  color: #1a1a1a;
  font-weight: 600;
}

/* 响应式 */
@media (max-width: 768px) {
  .team-cards {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .page-header h1 {
    font-size: 28px;
  }

  .resume-header,
  .resume-content {
    padding: 24px;
  }

  .resume-header h2 {
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/coreData/coreTeam.vue